import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { history } from "../store";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import {
  FileCheck,
  LockKeyholeOpen,
  CreditCard,
  ServerCog,
  DoorOpen,
} from "lucide-react";

import AppHeader from "../containers/AppHeader";
import { withNamespaces } from "react-i18next";
import {
  postBookemail,
  postQrsale,
  postBooking,
  postRedsysGetParams,
  fetchCustomer,
} from "../actions/qrs";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const TICKET_KEY = 'vacway_ticket';

class TicketView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pin: "*123456#",
      numero: "123",
      factura: "VLK0001000001",
      iva: 21,
      importeBase: null,
      importeIva: null,
      total: null,
      date: null,
      accessCode: "",
      forwardScreen: false,
      downloadingPDF: false,
      phoneNumber: "",
      mail: "",
      parque: "AQUALANDIA",
      zona: "1",
      accesible: "NO",
      reserva: "TODO EL DIA",
      confirmReservation: false,
      newsletterAcceptance: false,
      lockerPrice: null,
      descriptionZone: null,
      selectedAccessibility: null,
      zoneSelected: null,
      selectedLocker: null,
      lockerAssigned: null,
      lockerPrice: null,
      paymentId: null,
      qrToken: null,
      lockerPin: null,
      lockerMatricula: null,
      lockerCustomer: null,
      lockerInvoice: null,
      qrType: "pay",
      qrMode: 0,
      autorized: null,
      Ds_MerchantCode: null,
      Ds_MerchantName: "VACWAY TECH",
      Ds_Url: "https://vacway.com",
      Ds_AuthorisationCode: null,
      Ds_Date: null,
      Ds_Hour: null,
      startDate: new Date(),
      endDate: new Date(),
      doorAccess: 0,
    };

    this.generatePDF = this.generatePDF.bind(this);
  }

  goTo(number, e) {
    const searchParams = new URLSearchParams(this.props.location.search);
    const qrToken = searchParams.get("qrToken");

    history.push(`/qrsale/${qrToken}`);
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);

    const urlParams = new URLSearchParams(this.props.location.search);

    const zoneSelected         = urlParams.get("zoneSelected");
    const descriptionZone      = urlParams.get("descriptionZone");
    const selectedAccessibility = urlParams.get("selectedAccessibility");
    const selectedLocker       = urlParams.get("selectedLocker");
    const lockerPrice          = urlParams.get("lockerPrice");
    const lockerAssigned       = urlParams.get("lockerAssigned");
    const lockerPin            = urlParams.get("lockerPin");
    const lockerMatricula      = urlParams.get("lockerMatricula");
    const lockerCustomer       = urlParams.get("lockerCustomer");
    const qrToken              = urlParams.get("qrToken");
    const qrType               = urlParams.get("qrType");
    const qrMode               = urlParams.get("qrMode");
    const mail                 = urlParams.get("mail");
    const phoneNumber          = urlParams.get("phoneNumber");
    const newsletterAcceptance = urlParams.get("newsletterAcceptance");
    const confirmReservation   = urlParams.get("confirmReservation");
    const idNumber             = urlParams.get("idNumber") || '';
    const paymentId            = urlParams.get("paymentId");
    const language             = urlParams.get("language");
    const paymentDate          = new Date(urlParams.get("paymentDate"));

    this.props.i18n.changeLanguage(language);

    let today = new Date().toLocaleString();
    this.setState({ date: today });

    // ── Reload guard: restore from sessionStorage if ticket already processed ──
    const savedTicket = (() => {
      try { return JSON.parse(sessionStorage.getItem(TICKET_KEY)); } catch { return null; }
    })();

    if (savedTicket && savedTicket.lockerAssigned === lockerAssigned) {
      // Restore all URL-derived state plus the API result — no API calls needed
      this.setState({
        zoneSelected,
        descriptionZone,
        selectedAccessibility,
        selectedLocker,
        lockerAssigned,
        lockerPrice,
        paymentId,
        qrToken,
        lockerPin,
        lockerMatricula,
        lockerCustomer,
        qrType,
        qrMode:       Number(qrMode),
        lockerInvoice: savedTicket.lockerInvoice,
        accessCode:    savedTicket.accessCode,
        doorAccess:    savedTicket.doorAccess || 0,
        autorized:     true,
      }, () => this.TotalComponent());
      return;
    }

    // ── First-time authorization: block on page reload or non-today paymentDate ──
    let autorizeBookemail = true;

    const navigationEntries = window.performance.getEntriesByType("navigation");
    if (navigationEntries.length > 0 && navigationEntries[0].type === "reload") {
      console.log("Page was reloaded");
      autorizeBookemail = false;
    }

    const now = new Date();
    const isToday =
      paymentDate.getFullYear() === now.getFullYear() &&
      paymentDate.getMonth()    === now.getMonth()    &&
      paymentDate.getDate()     === now.getDate();

    if (!isToday) {
      autorizeBookemail = false;
      console.log("Ticket date is not today – possible reload or duplicate.");
    }

    this.setState({ autorized: autorizeBookemail });

    if (!autorizeBookemail) return;

    const { iva } = this.state;

    let salePetition = {};
    let bookEmail    = {};

    const madridTime = new Date(
      new Date().toLocaleString("en-US", { timeZone: "Europe/Madrid" })
    );
    const formattedDate = madridTime.toISOString().replace("T", " ").substring(0, 19);

    salePetition.TimeStamp     = formattedDate;
    salePetition.Amount        = parseInt(lockerPrice);
    salePetition.Code          = qrToken;
    salePetition.PaymentMethod = "QR";
    salePetition.WorkerSession = "000000";
    salePetition.Language      = language;
    salePetition.RedsysCode    = paymentId;
    salePetition.Locker        = lockerAssigned;
    salePetition.LockerPin     = lockerPin;
    salePetition.Phone         = phoneNumber;
    salePetition.Email         = mail;
    salePetition.IdNumber      = idNumber;

    this.setState(
      {
        zoneSelected,
        descriptionZone,
        selectedAccessibility,
        selectedLocker,
        lockerAssigned,
        lockerPrice,
        paymentId,
        qrToken,
        lockerPin,
        lockerMatricula,
        lockerCustomer,
        qrType,
        lockerInvoice: "XXXXXXXX",
        qrMode: Number(qrMode),
      },
      () => {
        this.TotalComponent();

        this.props
          .postBooking({
            LockerAssigned: lockerAssigned,
            LockerPin:      lockerPin,
            Phone:          phoneNumber,
            Origin:         "RQ",
            qrMode:         qrMode,
          })
          .then(() => {})
          .catch(console.error);
      }
    );

    this.props
      .postQrsale(salePetition)
      .then((answer) => {
        if (answer.response && answer.response.toSaveSale) {
          const answerSaleCode = answer.response.toSaveSale.Code;

          this.setState({ lockerInvoice: answerSaleCode });

          bookEmail.bookEmail            = mail;
          bookEmail.lockerMatricula      = lockerMatricula;
          bookEmail.lockerAssigned       = lockerAssigned;
          bookEmail.phoneNumber          = phoneNumber;
          bookEmail.lockerPin            = lockerPin;
          bookEmail.zoneSelected         = zoneSelected;
          bookEmail.selectedLocker       = selectedLocker;
          bookEmail.selectedAccessibility = selectedAccessibility;
          bookEmail.descriptionZone      = descriptionZone;
          bookEmail.lockerSelected       = this.getLockerType(selectedLocker);
          bookEmail.lockerCustomer       = lockerCustomer;
          bookEmail.lockerInvoice        = answerSaleCode;
          bookEmail.date                 = today;
          bookEmail.iva                  = iva;
          bookEmail.importeBase          = (lockerPrice / (1 + iva / 100)).toFixed(2);
          bookEmail.importeIva           = (lockerPrice - lockerPrice / (1 + iva / 100)).toFixed(2);
          bookEmail.total                = lockerPrice;
          bookEmail.qrMode               = qrMode;
          bookEmail.language             = language;

          this.props
            .postBookemail(bookEmail)
            .then((answer) => {
              const accessCode = answer.response.openingAccessCode;
              const doorCode   = answer.response.doorAccess || 0;

              this.setState({ accessCode, doorAccess: doorCode }, () => this.TotalComponent());

              // Persist to sessionStorage so reload restores the ticket without API calls
              try {
                sessionStorage.setItem(TICKET_KEY, JSON.stringify({
                  lockerAssigned,
                  lockerInvoice: answerSaleCode,
                  accessCode,
                  doorAccess: doorCode,
                }));
              } catch { /* ignore */ }
            })
            .catch(console.error);
        }
      })
      .catch(console.error);
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
    sessionStorage.removeItem(TICKET_KEY);
  }

  handleBeforeUnload = (event) => {
    // Set the returnValue property of the event to show the alert message
    event.preventDefault();
  };

  getImageDataURL = (imageUrl) => {
    return new Promise((resolve, reject) => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const image = new Image();

      image.onload = () => {
        canvas.width = image.width;
        canvas.height = image.height;
        ctx.drawImage(image, 0, 0);

        const dataURL = canvas.toDataURL("image/png");
        resolve(dataURL);
      };

      image.onerror = (error) => {
        reject(error);
      };

      image.src = imageUrl;
    });
  };

  TotalComponent() {
    const { iva, lockerPrice } = this.state;

    let importeBase = (lockerPrice / (1 + iva / 100)).toFixed(2);
    let importeIva = (lockerPrice - importeBase).toFixed(2);
    let total = lockerPrice;

    this.setState({
      importeBase: importeBase,
      importeIva: importeIva,
      total: total,
    });

    return { total, importeBase, importeIva, iva };
  }

  openLocker(qrToken) {
    console.log("forwardScreen: ", this.state.forwardScreen);

    window.location.href = `https://lockers-qr.vacway.es/qrsale/${qrToken}`;
  }

  getLockerType(type) {
    const { t, i18n } = this.props;

    switch (type) {
      case "BNS":
        return "Standard";
      case "CNS":
        return "Standard Carga";
      case "BWS":
        return "Standard XL";
      case "BNM":
        return "Medium";
      case "CNM":
        return "Medium Carga";
      case "BWM":
        return "Medium XL";
      case "CWM":
        return "Medium Carga XL";
      case "BNL":
        return "Large";
      case "CNL":
        return "Large Carga";
      case "BWL":
        return "Large XL";
      case "CWL":
        return "Large Carga XL";
      case "BNXL":
        return "Large";
      case "CNXL":
        return "Large Carga";
      case "BWXL":
        return "Large XL";
      case "CWXL":
        return "Large Carga XL";
      case "BN2XL":
        return "Large";
      case "CN2XL":
        return "Large Carga";
      case "BW2XL":
        return "Large XL";
      case "CW2XL":
        return "Large Carga XL";
      case "BN3XL":
        return "Ski";
      case "CN3XL":
        return "Ski Carga";
      case "BW3XL":
        return "Ski XL";
      case "BW3XL":
        return "Ski Carga XL";
      default:
        return "None";
    }
  }

  render() {
    const { t, i18n } = this.props;
    const {
      iva,
      importeBase,
      importeIva,
      total,
      date,
      accessCode,
      downloadingPDF,
      zoneSelected,
      selectedLocker,
      selectedAccessibility,
      lockerCustomer,
      lockerMatricula,
      lockerPin,
      lockerAssigned,
      lockerInvoice,
      descriptionZone,
      lockerSelected,
      qrToken,
      qrMode,
      autorized,
      doorAccess,
      startDate,
      endDate,
      pinAssigned,
      Ds_MerchantCode,
      Ds_MerchantName,
      Ds_Url,
      Ds_AuthorisationCode,
      Ds_Date,
      Ds_Hour,
    } = this.state;

    if (!autorized) {
      return (
        <div>
          <AppHeader />
          <div className="lockerContainer mt-5">
            <h3 className="lockTitle">
              <span className="text-vw-dark">
                {t("¡GRACIAS POR RESERVAR TU TAQUILLA!")}
              </span>
            </h3>
            <div
              className="col lockerErrorButtonBig"
              onClick={(e) => this.goTo(1, e)}
            >
              <h1>
                {t("VOLVER")}
                <br></br>
                {t("AL INICIO")}
              </h1>
            </div>
          </div>
        </div>
      );
    }

    if (!total) {
      return (
        <div class="spinner">
          <img src="/images/logo.png" alt="Logo" />
        </div>
      );
    }

    // Helper function to parse DD/MM/YYYY to a Date object
    // const parseDate = (dateString) => {
    //   const [day, month, year] = dateString.split("/"); // Split the string into parts
    //   return new Date(`${year}-${month}-${day}`); // Create a Date object
    // };

    // // Helper function to format a Date object as YYYY-MM-DD
    // const formatDate = (date) => {
    //   const year = date.getFullYear();
    //   const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is zero-based
    //   const day = String(date.getDate()).padStart(2, "0");
    //   return `${year}-${month}-${day}`;
    // };

    // // Parse startDate and get today's date
    // const today = formatDate(new Date());
    // const normalizedStartDate = formatDate(parseDate(startDate));

    // // Check if the startDate is the same as today's date
    // const isStartDateToday = startDate && normalizedStartDate === today;

    // console.log(`startDate: ${startDate} / ${today} / ${isStartDateToday}`);

    return (
      <div className="rentalBackground">
        <AppHeader />
        <div className="lockerContainer smartphone">
          <br></br>
          <div className="col flex align-items-center justify-content-center w-25 m-auto">
            <img src="/images/animated-icons/firecracker.gif" alt="finish" />
          </div>
          <h3 className="lockTitle">
            <span className="text-vw-dark">
              {t("¡GRACIAS POR RESERVAR TU TAQUILLA!")}
            </span>
          </h3>
          <div className="text-vw-semidark text-center">
            {t(
              "Sigue las instrucciones que encontrarás a continuación o en tu email."
            )}
          </div>
          <br></br>

          <div className="unified-form">
            <LockKeyholeOpen className="rental-phoneIcon" strokeWidth={1} />

            <div className="lockTitle">
              <span className="text-vw-semidark">
                {t("Información de taquilla")}
              </span>
            </div>

            <h4 className="lockTitle">
              {qrMode === 0 || qrMode === 3 ? (
                <span className="text-vw-light">
                  {t("Nº TAQUILLA")} - {t("PIN")}
                </span>
              ) : (
                <span className="text-vw-light">
                  {t("Nº TAQUILLA")} - {t("CÓDIGO DE ACCESO")}
                </span>
              )}
            </h4>
            <h3 className="lockTitle flex justify-content-around">
              {qrMode === 0 || qrMode === 3 ? (
                <span className="lockLabel">
                  Nº {lockerMatricula} - {lockerPin}
                </span>
              ) : (
                <span className="lockLabel">
                  Nº {lockerMatricula} - {accessCode}
                </span>
              )}
            </h3>
            {/* OPEN LOCKER */}
            {qrMode === 0 || qrMode === 3 ? (
              <div></div>
            ) : (
              <div className="row mt-2 mb-2">
                <div
                  className="col lockerContinueButton"
                  onClick={() => this.openLocker(qrToken)}
                >
                  <span>{t("ABRIR TAQUILLA")}</span>
                </div>
              </div>
            )}
          </div>

          {doorAccess != 0 && doorAccess != "" && (
            <div className="mt-4 unified-form">
              <DoorOpen className="rental-phoneIcon" strokeWidth={1} />

              <div className="lockTitle">
                <span className="text-vw-semidark">{t("ACCESO A LOCAL")}</span>
              </div>

              <h3 className="lockTitle flex justify-content-around">
                <span className="lockLabel">{doorAccess}</span>
              </h3>
            </div>
          )}

          <div className="mt-4 unified-form">
            <FileCheck className="rental-phoneIcon" strokeWidth={1} />

            <div className="lockTitle">
              <span className="text-vw-semidark">
                {t("Resumen de reserva")}
              </span>
            </div>

            {/* INVOICE */}
            <div className="rental-uf-row no-border">
              <div className="rental-uf-btn">
                <span className="rental-uf-label">
                  {t("Código de reserva")}
                </span>
                <span className="rental-uf-output">{lockerInvoice}</span>
              </div>
            </div>

            {/* ZONE */}
            <div className="mt-2 rental-uf-row no-border">
              <div className="rental-uf-btn">
                <span className="rental-uf-label">{t("Zona")}</span>
                <span className="rental-uf-output">
                  {zoneSelected} - {descriptionZone}
                </span>
              </div>
            </div>

            {/* DATES */}
            <div className="rental-uf-row no-border">
              <div className="d-flex">
                <div className="rental-uf-btn">
                  <span className="rental-uf-label">{t("Inicio")}</span>
                  <span className="rental-uf-output">{new Date().toLocaleDateString()}</span>
                </div>
                <vr class="vr"></vr>
                <div className="rental-uf-btn">
                  <span className="rental-uf-label">{t("Fin")}</span>
                  <span className="rental-uf-output">{new Date().toLocaleDateString()}</span>
                </div>
              </div>
            </div>
            <div className="rental-uf-row no-border">
              <div className="rental-uf-btn">
                <span className="rental-uf-label">{t("Hora Límite")}</span>
                <span className="rental-uf-output">23:59</span>
              </div>
            </div>

            {/* LOCKER */}
            <div className="rental-uf-row no-border">
              <div className="d-flex">
                <div className="rental-uf-btn">
                  <span className="rental-uf-label">{t("Taquilla")}</span>
                  <span className="rental-uf-output">
                    {this.getLockerType(selectedLocker)}
                  </span>
                </div>
                <vr class="vr"></vr>
                <div className="rental-uf-btn">
                  <span className="rental-uf-label">{t("Cantidad")}</span>
                  <span className="rental-uf-output">1</span>
                </div>
              </div>
            </div>

            {/* BASE */}
            <div className="mt-2 rental-uf-row no-border">
              <div className="d-flex">
                <div className="rental-uf-btn">
                  <span className="rental-uf-label">{t("Base")}</span>
                  <span className="rental-uf-output">{importeBase}€</span>
                </div>
                <vr class="vr"></vr>
                <div className="rental-uf-btn">
                  <span className="rental-uf-label">
                    {t("IVA")} ({iva}%)
                  </span>
                  <span className="rental-uf-output">{importeIva}€</span>
                </div>
              </div>
            </div>
            {/* TOTAL */}
            <div className="rental-uf-row no-border">
              <div className="rental-uf-btn">
                <span className="rental-uf-label">{t("Total")}</span>
                <span className="rental-uf-output">{total}€</span>
              </div>
            </div>

            {/* REDSYS */}
            {/* <div className="rental-uf-row no-border">
              <div className="rental-uf-btn">
                <span className="rental-uf-label">{t("Datos Operación")}</span>
                <span className="rental-uf-output">
                  {t("FUC: ")}
                  {Ds_MerchantCode}
                </span>
                <span className="rental-uf-output">
                  {t("COMERCIO: ")}
                  {Ds_MerchantName}
                </span>
                <span className="rental-uf-output">
                  {t("URL: ")}
                  {Ds_Url}
                </span>
                <span className="rental-uf-output">
                  {t("AUTH: ")}
                  {Ds_AuthorisationCode}
                </span>
                <span className="rental-uf-output">
                  {t("FECHA: ")}
                  {Ds_Hour}/{Ds_Date}
                </span>
              </div>
            </div> */}

            {/* DOWNLOAD PDF */}
            {downloadingPDF ? (
              <div class="spinner">
                <img src="/images/logo.png" alt="Logo" />
              </div>
            ) : (
              <div className="row mt-2 mb-2">
                <div
                  className="col lockerContinueButton"
                  onClick={this.generatePDF}
                >
                  <span>{t("DESCARGAR TICKET")}</span>
                </div>
              </div>
            )}

            <div className="row w-100 text-center">
              <div className="mt-5 w-100 text-center">
                <span className="text-vw-semidark rental-phone-advert">
                  {t(
                    "*Si deseas obtener el Pin en formato físico para llevarlo durante tu estancia en el parque contacta con los responsables de la zona de taquillas y enséñales tu email de reserva."
                  )}
                </span>
              </div>
            </div>
          </div>

          {qrMode === 0 && (
            <div className="mt-4 unified-form">
              <ServerCog className="rental-phoneIcon" strokeWidth={1} />

              <div className="lockTitle">
                <span className="text-vw-semidark">{t("Instrucciones")}</span>
              </div>

              <hr className="bg-vw-dark" />
              <div className="row">
                <div className="col flex align-items-center">
                  <img
                    src="/images/lockerBasicClosedStep1.svg"
                    alt="Locker Charger"
                    className="lockerTicketImage"
                  />
                </div>
                <div className="col">
                  <h5>
                    <span className="rental-uf-label">{t("PASO 1")}</span>
                  </h5>
                  <h5>
                    <span className="rental-uf-output">
                      {t("LOCALIZA TU TAQUILLA")}
                    </span>
                  </h5>
                </div>
              </div>
              <hr className="bg-vw-dark" />
              <div className="row">
                <div className="col">
                  <h5>
                    <span className="rental-uf-label">{t("PASO 2")}</span>
                  </h5>
                  <h5>
                    <span className="rental-uf-output">
                      {t("TOCA EL TECLADO")}
                    </span>
                  </h5>
                </div>
                <div className="col flex align-items-center">
                  <img
                    src="/images/lockerBasicClosedStep2.svg"
                    alt="Locker Charger"
                    className="lockerTicketImage"
                  />
                </div>
              </div>
              <hr className="bg-vw-dark" />
              <div className="row">
                <div className="col flex align-items-center">
                  <img
                    src="/images/lockerBasicClosedStep3.svg"
                    alt="Locker Charger"
                    className="lockerTicketImage"
                  />
                </div>
                <div className="col">
                  <h5>
                    <span className="rental-uf-label">{t("PASO 3")}</span>
                  </h5>
                  <h5>
                    <span className="rental-uf-output">
                      {t("INTRODUCE TU PIN")}
                    </span>
                  </h5>
                </div>
              </div>
              <hr className="bg-vw-dark" />
              <div className="row">
                <div className="col">
                  <h5>
                    <span className="rental-uf-label">{t("PASO 4")}</span>
                  </h5>
                  <h5>
                    <span className="rental-uf-output">
                      {t("ABRE LAS VECES QUE QUIERAS")}
                    </span>
                  </h5>
                </div>
                <div className="col flex align-items-center">
                  <img
                    src="/images/lockerBasicOpenedStep4.svg"
                    alt="Locker Charger"
                    className="lockerTicketImage"
                  />
                </div>
              </div>
            </div>
          )}
          {qrMode === 1 && (
            <div className="mt-4 unified-form">
              <ServerCog className="rental-phoneIcon" strokeWidth={1} />

              <div className="lockTitle">
                <span className="text-vw-semidark">{t("Instrucciones")}</span>
              </div>

              <hr className="bg-vw-dark" />
              <div className="row">
                <div className="col flex align-items-center">
                  <img
                    src="/images/qr.png"
                    alt="Locker Charger"
                    className="lockerTicketImage"
                  />
                </div>
                <div className="col">
                  <h5>
                    <span className="rental-uf-label">{t("PASO 1")}</span>
                  </h5>
                  <h5>
                    <span className="rental-uf-output">
                      {t('APRIETA "ABRIR TAQUILLA" O ESCANEA EL QR')}
                    </span>
                  </h5>
                </div>
              </div>
              <hr className="bg-vw-dark" />
              <div className="row">
                <div className="col">
                  <h5>
                    <span className="rental-uf-label">{t("PASO 2")}</span>
                  </h5>
                  <h5>
                    <span className="rental-uf-output">
                      {t("ACCEDE CON TUS CREDENCIALES")}
                    </span>
                  </h5>
                </div>
                <div className="col flex align-items-center">
                  <img
                    src="/images/lockerOTOStep2.svg"
                    alt="Locker Charger"
                    className="lockerTicketImage"
                  />
                </div>
              </div>
              <hr className="bg-vw-dark" />
              <div className="row">
                <div className="col flex align-items-center">
                  <img
                    src="/images/lockerOpen.png"
                    alt="Locker Charger"
                    className="lockerTicketImage"
                  />
                </div>
                <div className="col">
                  <h5>
                    <span className="rental-uf-label">{t("PASO 3")}</span>
                  </h5>
                  <h5>
                    <span className="rental-uf-output">
                      {t("SELECCIONA ABRIR AHORA")}
                    </span>
                  </h5>
                </div>
              </div>
              <hr className="bg-vw-dark" />
              <div className="row">
                <div className="col">
                  <h5>
                    <span className="rental-uf-label">{t("PASO 4")}</span>
                  </h5>
                  <h5>
                    <span className="rental-uf-output">
                      {t("DISPONES DE 2 APERTURAS")}
                    </span>
                  </h5>
                </div>
                <div className="col flex align-items-center">
                  <img
                    src="/images/lockerBasicOpenedStep4.svg"
                    alt="Locker Charger"
                    className="lockerTicketImage"
                  />
                </div>
              </div>
            </div>
          )}
          {qrMode === 3 && (
            <div className="mt-4 unified-form">
              <ServerCog className="rental-phoneIcon" strokeWidth={1} />

              <div className="lockTitle">
                <span className="text-vw-semidark">{t("Instrucciones")}</span>
              </div>

              <hr className="bg-vw-dark" />
              <div className="row">
                <div className="col flex align-items-center">
                  <img
                    src="/images/lockerBasicClosedStep1.svg"
                    alt="Locker Charger"
                    className="lockerTicketImage"
                  />
                </div>
                <div className="col">
                  <h5>
                    <span className="rental-uf-label">{t("PASO 1")}</span>
                  </h5>
                  <h5>
                    <span className="rental-uf-output">
                      {t("LOCALIZA TU TAQUILLA")}
                    </span>
                  </h5>
                </div>
              </div>
              <hr className="bg-vw-dark" />
              <div className="row">
                <div className="col">
                  <h5>
                    <span className="rental-uf-label">{t("PASO 2")}</span>
                  </h5>
                  <h5>
                    <span className="rental-uf-output">
                      {t("TOCA EL TECLADO")}
                    </span>
                  </h5>
                </div>
                <div className="col flex align-items-center">
                  <img
                    src="/images/lockerBasicClosedStep2.svg"
                    alt="Locker Charger"
                    className="lockerTicketImage"
                  />
                </div>
              </div>
              <hr className="bg-vw-dark" />
              <div className="row">
                <div className="col flex align-items-center">
                  <img
                    src="/images/lockerBasicClosedStep3.svg"
                    alt="Locker Charger"
                    className="lockerTicketImage"
                  />
                </div>
                <div className="col">
                  <h5>
                    <span className="rental-uf-label">{t("PASO 3")}</span>
                  </h5>
                  <h5>
                    <span className="rental-uf-output">
                      {t("INTRODUCE TU PIN")}
                    </span>
                  </h5>
                </div>
              </div>
              <hr className="bg-vw-dark" />
              <div className="row">
                <div className="col">
                  <h5>
                    <span className="rental-uf-label">{t("PASO 4")}</span>
                  </h5>
                  <h5>
                    <span className="rental-uf-output">
                      {t(
                        "ABRE 1 VEZ PARA GUARDAR TUS COSAS, UNA VEZ CIERRES DISPONES DE UNA APERTURA MÁS PARA SACARLAS"
                      )}
                    </span>
                  </h5>
                </div>
                <div className="col flex align-items-center">
                  <img
                    src="/images/lockerBasicOpenedStep4.svg"
                    alt="Locker Charger"
                    className="lockerTicketImage"
                  />
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="lockerContainer pc">
          <div className="col flex align-items-center justify-content-center w-25 m-auto">
            <img
              className="mx-auto d-block"
              src="/images/animated-icons/firecracker.gif"
              alt="finish"
            />
          </div>
          <h3 className="lockTitle">
            <span className="text-vw-dark">
              {t("¡GRACIAS POR RESERVAR TU TAQUILLA!")}
            </span>
          </h3>
          <div className="lockTitle">
            <span className="text-vw-semidark">
              {t(
                "Sigue las instrucciones que encontrarás a continuación o en tu email."
              )}
            </span>
          </div>
          <div className="mt-4 row">
            <div className="col-4">
              <div className="unified-form">
                <FileCheck className="rental-phoneIcon" strokeWidth={1} />

                <div className="lockTitle">
                  <span className="text-vw-semidark">
                    {t("Resumen de reserva")}
                  </span>
                </div>

                {/* INVOICE */}
                <div className="rental-uf-row no-border">
                  <div className="rental-uf-btn">
                    <span className="rental-uf-label">
                      {t("Código de reserva")}
                    </span>
                    <span className="rental-uf-output">{lockerInvoice}</span>
                  </div>
                </div>

                {/* ZONE */}
                <div className="mt-2 rental-uf-row no-border">
                  <div className="rental-uf-btn">
                    <span className="rental-uf-label">{t("Zona")}</span>
                    <span className="rental-uf-output">
                      {zoneSelected} - {descriptionZone}
                    </span>
                  </div>
                </div>

                {/* DATES */}
                <div className="rental-uf-row no-border">
                  <div className="d-flex">
                    <div className="rental-uf-btn">
                      <span className="rental-uf-label">{t("Inicio")}</span>
                      <span className="rental-uf-output">{new Date().toLocaleDateString()}</span>
                    </div>
                    <vr class="vr"></vr>
                    <div className="rental-uf-btn">
                      <span className="rental-uf-label">{t("Fin")}</span>
                      <span className="rental-uf-output">{new Date().toLocaleDateString()}</span>
                    </div>
                  </div>
                </div>
                <div className="rental-uf-row no-border">
                  <div className="rental-uf-btn">
                    <span className="rental-uf-label">{t("Hora Límite")}</span>
                    <span className="rental-uf-output">23:59</span>
                  </div>
                </div>

                {/* LOCKER */}
                <div className="rental-uf-row no-border">
                  <div className="d-flex">
                    <div className="rental-uf-btn">
                      <span className="rental-uf-label">{t("Taquilla")}</span>
                      <span className="rental-uf-output">
                        {this.getLockerType(selectedLocker)}
                      </span>
                    </div>
                    <vr class="vr"></vr>
                    <div className="rental-uf-btn">
                      <span className="rental-uf-label">{t("Cantidad")}</span>
                      <span className="rental-uf-output">1</span>
                    </div>
                  </div>
                </div>

                {/* BASE */}
                <div className="mt-2 rental-uf-row no-border">
                  <div className="d-flex">
                    <div className="rental-uf-btn">
                      <span className="rental-uf-label">{t("Base")}</span>
                      <span className="rental-uf-output">{importeBase}€</span>
                    </div>
                    <vr class="vr"></vr>
                    <div className="rental-uf-btn">
                      <span className="rental-uf-label">
                        {t("IVA")} ({iva}%)
                      </span>
                      <span className="rental-uf-output">{importeIva}€</span>
                    </div>
                  </div>
                </div>
                {/* TOTAL */}
                <div className="rental-uf-row no-border">
                  <div className="rental-uf-btn">
                    <span className="rental-uf-label">{t("Total")}</span>
                    <span className="rental-uf-output">{total}€</span>
                  </div>
                </div>

                {/* REDSYS */}
                {/* <div className="rental-uf-row no-border">
                  <div className="rental-uf-btn">
                    <span className="rental-uf-label">
                      {t("Datos Operación")}
                    </span>
                    <span className="rental-uf-output">
                      {t("FUC: ")}
                      {Ds_MerchantCode}
                    </span>
                    <span className="rental-uf-output">
                      {t("COMERCIO: ")}
                      {Ds_MerchantName}
                    </span>
                    <span className="rental-uf-output">
                      {t("URL: ")}
                      {Ds_Url}
                    </span>
                    <span className="rental-uf-output">
                      {t("AUTH: ")}
                      {Ds_AuthorisationCode}
                    </span>
                    <span className="rental-uf-output">
                      {t("FECHA: ")}
                      {Ds_Hour}/{Ds_Date}
                    </span>
                  </div>
                </div> */}

                {/* DOWNLOAD PDF */}
                {downloadingPDF ? (
                  <div class="spinner">
                    <img src="/images/logo.png" alt="Logo" />
                  </div>
                ) : (
                  <div className="row mt-2 mb-2">
                    <div
                      className="col lockerDownloadButton"
                      onClick={this.generatePDF}
                    >
                      <span>{t("DESCARGAR TICKET")}</span>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="col-4">
              <div className="unified-form h-auto">
                <LockKeyholeOpen className="rental-phoneIcon" strokeWidth={1} />

                <div className="lockTitle">
                  <span className="text-vw-semidark">
                    {t("Información de taquilla")}
                  </span>
                </div>

                <h4 className="lockTitle">
                  {qrMode === 0 || qrMode === 3 ? (
                    <span className="text-vw-light">
                      {t("Nº TAQUILLA")} - {t("PIN")}
                    </span>
                  ) : (
                    <span className="text-vw-light">
                      {t("Nº TAQUILLA")} - {t("CÓDIGO DE ACCESO")}
                    </span>
                  )}
                </h4>
                <h3 className="lockTitle flex justify-content-around">
                  {qrMode === 0 || qrMode === 3 ? (
                    <span className="lockLabel">
                      Nº {lockerMatricula} - {lockerPin}
                    </span>
                  ) : (
                    <span className="lockLabel">
                      Nº {lockerMatricula} - {accessCode}
                    </span>
                  )}
                </h3>
                {/* OPEN LOCKER */}
                {qrMode === 0 || qrMode === 3 ? (
                  <div></div>
                ) : (
                  <div className="row mt-2 mb-2">
                    <div
                      className="col lockerContinueButton"
                      onClick={() => this.openLocker(qrToken)}
                    >
                      <span>{t("ABRIR TAQUILLA")}</span>
                    </div>
                  </div>
                )}

                <div className="row w-100 text-center">
                  <div className="mt-5 w-100 text-center">
                    <span className="text-vw-semidark rental-phone-advert">
                      {t(
                        "*Si deseas obtener el Pin en formato físico para llevarlo durante tu estancia en el parque contacta con los responsables de la zona de taquillas y enséñales tu email de reserva."
                      )}
                    </span>
                  </div>
                </div>
              </div>

              {doorAccess != 0 && doorAccess != "" && (
                <div className="mt-4 unified-form h-auto">
                  <DoorOpen className="rental-phoneIcon" strokeWidth={1} />

                  <div className="lockTitle">
                    <span className="text-vw-semidark">
                      {t("ACCESO A LOCAL")}
                    </span>
                  </div>

                  <h3 className="lockTitle flex justify-content-around">
                    <span className="lockLabel">{doorAccess}</span>
                  </h3>
                </div>
              )}
            </div>

            <div className="col-4">
              {qrMode === 0 && (
                <div className="unified-form h-auto">
                  <ServerCog className="rental-phoneIcon" strokeWidth={1} />

                  <div className="lockTitle">
                    <span className="text-vw-semidark">
                      {t("Instrucciones")}
                    </span>
                  </div>

                  <hr className="bg-vw-dark" />
                  <div className="row">
                    <div className="col flex align-items-center">
                      <img
                        src="/images/lockerBasicClosedStep1.svg"
                        alt="Locker Charger"
                        className="lockerTicketImage"
                      />
                    </div>
                    <div className="col">
                      <h5>
                        <span className="rental-uf-label">{t("PASO 1")}</span>
                      </h5>
                      <h5>
                        <span className="rental-uf-output">
                          {t("LOCALIZA TU TAQUILLA")}
                        </span>
                      </h5>
                    </div>
                  </div>
                  <hr className="bg-vw-dark" />
                  <div className="row">
                    <div className="col">
                      <h5>
                        <span className="rental-uf-label">{t("PASO 2")}</span>
                      </h5>
                      <h5>
                        <span className="rental-uf-output">
                          {t("TOCA EL TECLADO")}
                        </span>
                      </h5>
                    </div>
                    <div className="col flex align-items-center">
                      <img
                        src="/images/lockerBasicClosedStep2.svg"
                        alt="Locker Charger"
                        className="lockerTicketImage"
                      />
                    </div>
                  </div>
                  <hr className="bg-vw-dark" />
                  <div className="row">
                    <div className="col flex align-items-center">
                      <img
                        src="/images/lockerBasicClosedStep3.svg"
                        alt="Locker Charger"
                        className="lockerTicketImage"
                      />
                    </div>
                    <div className="col">
                      <h5>
                        <span className="rental-uf-label">{t("PASO 3")}</span>
                      </h5>
                      <h5>
                        <span className="rental-uf-output">
                          {t("INTRODUCE TU PIN")}
                        </span>
                      </h5>
                    </div>
                  </div>
                  <hr className="bg-vw-dark" />
                  <div className="row">
                    <div className="col">
                      <h5>
                        <span className="rental-uf-label">{t("PASO 4")}</span>
                      </h5>
                      <h5>
                        <span className="rental-uf-output">
                          {t("ABRE LAS VECES QUE QUIERAS")}
                        </span>
                      </h5>
                    </div>
                    <div className="col flex align-items-center">
                      <img
                        src="/images/lockerBasicOpenedStep4.svg"
                        alt="Locker Charger"
                        className="lockerTicketImage"
                      />
                    </div>
                  </div>
                </div>
              )}
              {qrMode === 1 && (
                <div className="unified-form h-auto">
                  <ServerCog className="rental-phoneIcon" strokeWidth={1} />

                  <div className="lockTitle">
                    <span className="text-vw-semidark">
                      {t("Instrucciones")}
                    </span>
                  </div>

                  <hr className="bg-vw-dark" />
                  <div className="row">
                    <div className="col flex align-items-center">
                      <img
                        src="/images/qr.png"
                        alt="Locker Charger"
                        className="lockerTicketImage"
                      />
                    </div>
                    <div className="col">
                      <h5>
                        <span className="rental-uf-label">{t("PASO 1")}</span>
                      </h5>
                      <h5>
                        <span className="rental-uf-output">
                          {t('APRIETA "ABRIR TAQUILLA" O ESCANEA EL QR')}
                        </span>
                      </h5>
                    </div>
                  </div>
                  <hr className="bg-vw-dark" />
                  <div className="row">
                    <div className="col">
                      <h5>
                        <span className="rental-uf-label">{t("PASO 2")}</span>
                      </h5>
                      <h5>
                        <span className="rental-uf-output">
                          {t("ACCEDE CON TUS CREDENCIALES")}
                        </span>
                      </h5>
                    </div>
                    <div className="col flex align-items-center">
                      <img
                        src="/images/lockerOTOStep2.svg"
                        alt="Locker Charger"
                        className="lockerTicketImage"
                      />
                    </div>
                  </div>
                  <hr className="bg-vw-dark" />
                  <div className="row">
                    <div className="col flex align-items-center">
                      <img
                        src="/images/lockerOpen.png"
                        alt="Locker Charger"
                        className="lockerTicketImage"
                      />
                    </div>
                    <div className="col">
                      <h5>
                        <span className="rental-uf-label">{t("PASO 3")}</span>
                      </h5>
                      <h5>
                        <span className="rental-uf-output">
                          {t("SELECCIONA ABRIR AHORA")}
                        </span>
                      </h5>
                    </div>
                  </div>
                  <hr className="bg-vw-dark" />
                  <div className="row">
                    <div className="col">
                      <h5>
                        <span className="rental-uf-label">{t("PASO 4")}</span>
                      </h5>
                      <h5>
                        <span className="rental-uf-output">
                          {t("DISPONES DE 2 APERTURAS")}
                        </span>
                      </h5>
                    </div>
                    <div className="col flex align-items-center">
                      <img
                        src="/images/lockerBasicOpenedStep4.svg"
                        alt="Locker Charger"
                        className="lockerTicketImage"
                      />
                    </div>
                  </div>
                </div>
              )}
              {qrMode === 3 && (
                <div className="unified-form h-auto">
                  <ServerCog className="rental-phoneIcon" strokeWidth={1} />

                  <div className="lockTitle">
                    <span className="text-vw-semidark">
                      {t("Instrucciones")}
                    </span>
                  </div>

                  <hr className="bg-vw-dark" />
                  <div className="row">
                    <div className="col flex align-items-center">
                      <img
                        src="/images/lockerBasicClosedStep1.svg"
                        alt="Locker Charger"
                        className="lockerTicketImage"
                      />
                    </div>
                    <div className="col">
                      <h5>
                        <span className="rental-uf-label">{t("PASO 1")}</span>
                      </h5>
                      <h5>
                        <span className="rental-uf-output">
                          {t("LOCALIZA TU TAQUILLA")}
                        </span>
                      </h5>
                    </div>
                  </div>
                  <hr className="bg-vw-dark" />
                  <div className="row">
                    <div className="col">
                      <h5>
                        <span className="rental-uf-label">{t("PASO 2")}</span>
                      </h5>
                      <h5>
                        <span className="rental-uf-output">
                          {t("TOCA EL TECLADO")}
                        </span>
                      </h5>
                    </div>
                    <div className="col flex align-items-center">
                      <img
                        src="/images/lockerBasicClosedStep2.svg"
                        alt="Locker Charger"
                        className="lockerTicketImage"
                      />
                    </div>
                  </div>
                  <hr className="bg-vw-dark" />
                  <div className="row">
                    <div className="col flex align-items-center">
                      <img
                        src="/images/lockerBasicClosedStep3.svg"
                        alt="Locker Charger"
                        className="lockerTicketImage"
                      />
                    </div>
                    <div className="col">
                      <h5>
                        <span className="rental-uf-label">{t("PASO 3")}</span>
                      </h5>
                      <h5>
                        <span className="rental-uf-output">
                          {t("INTRODUCE TU PIN")}
                        </span>
                      </h5>
                    </div>
                  </div>
                  <hr className="bg-vw-dark" />
                  <div className="row">
                    <div className="col">
                      <h5>
                        <span className="rental-uf-label">{t("PASO 4")}</span>
                      </h5>
                      <h5>
                        <span className="rental-uf-output">
                          {t(
                            "ABRE 1 VEZ PARA GUARDAR TUS COSAS, UNA VEZ CIERRES DISPONES DE UNA APERTURA MÁS PARA SACARLAS"
                          )}
                        </span>
                      </h5>
                    </div>
                    <div className="col flex align-items-center">
                      <img
                        src="/images/lockerBasicOpenedStep4.svg"
                        alt="Locker Charger"
                        className="lockerTicketImage"
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  generatePDF = async () => {
    const {
      iva,
      importeBase,
      importeIva,
      total,
      date,
      accessCode,
      lockerInvoice,
      zoneSelected,
      selectedLocker,
      selectedAccessibility,
      lockerCustomer,
      lockerMatricula,
      lockerPin,
      descriptionZone,
      qrMode,
    } = this.state;

    const { t, i18n } = this.props;

    this.setState({ downloadingPDF: true });

    const logocolorDataURL = await this.getImageDataURL(
      "/images/logocolor.png"
    );

    const step1DataURL = await this.getImageDataURL(
      "/images/lockerBasicClosedStep1.png"
    );
    const step2DataURL = await this.getImageDataURL(
      "/images/lockerBasicClosedStep2.png"
    );
    const step3DataURL = await this.getImageDataURL(
      "/images/lockerBasicClosedStep3.png"
    );
    const step4DataURL = await this.getImageDataURL(
      "/images/lockerBasicOpenedStep4.png"
    );

    const step1OTODataURL = await this.getImageDataURL("/images/qr.png");
    const step2OTODataURL = await this.getImageDataURL(
      "/images/lockerOTOStep2.png"
    );
    const step3OTODataURL = await this.getImageDataURL(
      "/images/lockerOpen.png"
    );
    const step4OTODataURL = await this.getImageDataURL(
      "/images/lockerBasicOpenedStep4.png"
    );

    const docDefinition = {
      footer: {
        columns: [
          {
            text: `${t("Más información y garantía en www.vacway.com")}`,
            style: "documentFooterCenter",
          },
        ],
      },
      content: [
        {
          columns: [
            {
              image: logocolorDataURL,
              width: 150,
            },

            [
              {
                text: `${t("TICKET")}`,
                style: "invoiceTitle",
                width: "*",
              },
              {
                stack: [
                  {
                    columns: [
                      {
                        text: `${t("Factura Simplificada")}`,
                        style: "invoiceSubTitle",
                        width: "*",
                      },
                      {
                        text: `${lockerInvoice}`,
                        style: "invoiceSubValue",
                        width: 150,
                      },
                    ],
                  },
                  {
                    columns: [
                      {
                        text: `${t("Fecha y Hora")}`,
                        style: "invoiceSubTitle",
                        width: "*",
                      },
                      {
                        text: new Date().toLocaleString(),
                        style: "invoiceSubValue",
                        width: 150,
                      },
                    ],
                  },
                ],
              },
            ],
          ],
        },
        {
          columns: [
            {
              text: `${t("INFORMACIÓN DE TU LOCKER:")}`,
              style: "invoiceBillingTitle",
            },
            {
              text: "VACWAY WATERPROOF S.L",
              style: "invoiceBillingTitle",
            },
          ],
        },
        {
          columns: [
            {
              text: `${t("Nº TAQUILLA")}:  ${lockerMatricula}\n ${t(
                "PIN"
              )}: ${lockerPin}\n ${t("ZONA")}: ${zoneSelected} \n ${t(
                "TIPO"
              )}: ${this.getLockerType(selectedLocker)}\n ${t(
                "ACCESIBLE"
              )}: ${selectedAccessibility} \n ${t(
                "UBICACIÓN"
              )}: ${lockerCustomer}`,
              style: "invoiceBillingDetails",
            },
            {
              text: "Albert Einstein, 46 \n 08223 Terrassa \n Barcelona, España \n NIF: B66983032",
              style: "invoiceBillingDetails",
            },
          ],
        },
        "\n\n",
        {
          table: {
            headerRows: 1,
            widths: ["*", 40, "auto", 40, "auto", 80],

            body: [
              [
                {
                  text: `${t("Producto")}`,
                  style: "itemsHeader",
                },
                {
                  text: `${t("UNIDADES")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("IMPORTE BASE")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("IVA")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("IMPORTE IVA")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("TOTAL")}`,
                  style: ["itemsHeader", "center"],
                },
              ],
              [
                [
                  {
                    text: `${this.getLockerType(selectedLocker)}`,
                    style: "itemTitle",
                  },
                ],
                {
                  text: "1",
                  style: "itemNumber",
                },
                {
                  text: `${importeBase}`,
                  style: "itemNumber",
                },
                {
                  text: `${iva}%`,
                  style: "itemNumber",
                },
                {
                  text: `${importeIva}`,
                  style: "itemNumber",
                },
                {
                  text: `${total}`,
                  style: "itemTotal",
                },
              ],
              // END Items
            ],
          },
          layout: "lightHorizontalLines",
        },
        {
          text: `${t("PASO 1")}`,
          style: "notesTitle",
          width: "*",
        },
        {
          columns: [
            {
              image: step1DataURL,
              height: 80,
              width: 80,
            },

            {
              text: `\n${t("LOCALIZA TU TAQUILLA")}`,
            },
          ],
        },
        {
          text: `${t("PASO 2")}`,
          style: "notesTitle",
          width: "*",
        },
        {
          columns: [
            {
              image: step2DataURL,
              height: 80,
              width: 80,
            },

            {
              text: `\n${t("TOCA EL TECLADO")}`,
            },
          ],
        },
        {
          text: `${t("PASO 3")}`,
          style: "notesTitle",
          width: "*",
        },
        {
          columns: [
            {
              image: step3DataURL,
              height: 80,
              width: 80,
            },

            {
              text: `\n${t("INTRODUCE TU PIN")}`,
            },
          ],
        },
        {
          text: `${t("PASO 4")}`,
          style: "notesTitle",
          width: "*",
        },
        {
          columns: [
            {
              image: step4DataURL,
              height: 80,
              width: 120,
            },

            {
              text: `\n${t("ABRE LAS VECES QUE QUIERAS")}`,
            },
          ],
        },
      ],

      styles: {
        // Document Footer
        documentFooterLeft: {
          fontSize: 10,
          margin: [5, 5, 5, 5],
          alignment: "left",
        },
        documentFooterCenter: {
          fontSize: 10,
          margin: [5, 5, 5, 5],
          alignment: "center",
        },
        documentFooterRight: {
          fontSize: 10,
          margin: [5, 5, 5, 5],
          alignment: "right",
        },
        invoiceTitle: {
          fontSize: 22,
          bold: true,
          alignment: "right",
          margin: [0, 0, 0, 15],
        },
        instrucciones: {
          fontSize: 22,
          bold: true,
          alignment: "left",
          margin: [0, 0, 0, 15],
        },
        invoiceSubTitle: {
          fontSize: 12,
          alignment: "right",
        },
        invoiceSubValue: {
          fontSize: 12,
          alignment: "right",
        },
        invoiceBillingTitle: {
          fontSize: 14,
          bold: true,
          alignment: "left",
          margin: [0, 20, 0, 5],
        },
        invoiceBillingDetails: {
          alignment: "left",
          bold: true,
        },
        itemsHeader: {
          margin: [0, 5, 0, 5],
          bold: true,
        },
        itemTitle: {
          bold: true,
        },
        itemNumber: {
          margin: [0, 5, 0, 5],
          alignment: "center",
        },
        itemTotal: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "center",
        },

        itemsFooterSubTitle: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "right",
        },
        itemsFooterSubValue: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "center",
        },
        foto1: {
          alignment: "left",
        },
        itemsFooterTotalTitle: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "right",
        },
        itemsFooterTotalValue: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "center",
        },
        signaturePlaceholder: {
          margin: [0, 70, 0, 0],
        },
        signatureName: {
          bold: true,
          alignment: "center",
        },
        signatureJobTitle: {
          italics: true,
          fontSize: 10,
          alignment: "center",
        },
        notesTitle: {
          fontSize: 16,
          bold: true,
          margin: [0, 10, 0, 3],
          alignment: "center",
        },
        notesText: {
          fontSize: 10,
        },
        center: {
          alignment: "center",
        },
      },
      defaultStyle: {
        columnGap: 20,
      },
    };

    const docOTODefinition = {
      footer: {
        columns: [
          {
            text: `${t("Más información y garantía en www.vacway.com")}`,
            style: "documentFooterCenter",
          },
        ],
      },
      content: [
        {
          columns: [
            {
              image: logocolorDataURL,
              width: 150,
            },

            [
              {
                text: `${t("TICKET")}`,
                style: "invoiceTitle",
                width: "*",
              },
              {
                stack: [
                  {
                    columns: [
                      {
                        text: `${t("Factura Simplificada")}`,
                        style: "invoiceSubTitle",
                        width: "*",
                      },
                      {
                        text: `${lockerInvoice}`,
                        style: "invoiceSubValue",
                        width: 150,
                      },
                    ],
                  },
                  {
                    columns: [
                      {
                        text: `${t("Fecha y Hora")}`,
                        style: "invoiceSubTitle",
                        width: "*",
                      },
                      {
                        text: new Date().toLocaleString(),
                        style: "invoiceSubValue",
                        width: 150,
                      },
                    ],
                  },
                ],
              },
            ],
          ],
        },
        {
          columns: [
            {
              text: `${t("INFORMACIÓN DE TU LOCKER:")}`,
              style: "invoiceBillingTitle",
            },
            {
              text: "VACWAY WATERPROOF S.L",
              style: "invoiceBillingTitle",
            },
          ],
        },
        {
          columns: [
            {
              text: `${t("Nº TAQUILLA")}:  ${lockerMatricula}\n ${t(
                "CÓDIGO DE ACCESO"
              )}: ${accessCode}\n ${t("ZONA")}: ${zoneSelected} \n ${t(
                "TIPO"
              )}: ${this.getLockerType(selectedLocker)}\n ${t(
                "ACCESIBLE"
              )}: ${selectedAccessibility} \n ${t(
                "UBICACIÓN"
              )}: ${lockerCustomer}`,
              style: "invoiceBillingDetails",
            },
            {
              text: "Albert Einstein, 46 \n 08223 Terrassa \n Barcelona, España \n NIF: B66983032",
              style: "invoiceBillingDetails",
            },
          ],
        },
        "\n\n",
        {
          table: {
            headerRows: 1,
            widths: ["*", 40, "auto", 40, "auto", 80],

            body: [
              [
                {
                  text: `${t("Producto")}`,
                  style: "itemsHeader",
                },
                {
                  text: `${t("UNIDADES")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("IMPORTE BASE")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("IVA")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("IMPORTE IVA")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("TOTAL")}`,
                  style: ["itemsHeader", "center"],
                },
              ],
              [
                [
                  {
                    text: `${this.getLockerType(selectedLocker)}`,
                    style: "itemTitle",
                  },
                ],
                {
                  text: "1",
                  style: "itemNumber",
                },
                {
                  text: `${importeBase}`,
                  style: "itemNumber",
                },
                {
                  text: `${iva}%`,
                  style: "itemNumber",
                },
                {
                  text: `${importeIva}`,
                  style: "itemNumber",
                },
                {
                  text: `${total}`,
                  style: "itemTotal",
                },
              ],
              // END Items
            ],
          },
          layout: "lightHorizontalLines",
        },
        {
          text: `${t("PASO 1")}`,
          style: "notesTitle",
          width: "*",
        },
        {
          columns: [
            {
              image: step1OTODataURL,
              height: 80,
              width: 80,
            },

            {
              text: `\n${t('APRIETA "ABRIR TAQUILLA" O ESCANEA EL QR')}`,
            },
          ],
        },
        {
          text: `${t("PASO 2")}`,
          style: "notesTitle",
          width: "*",
        },
        {
          columns: [
            {
              image: step2OTODataURL,
              height: 80,
              width: 80,
            },

            {
              text: `\n${t("ACCEDE CON TUS CREDENCIALES")}`,
            },
          ],
        },
        {
          text: `${t("PASO 3")}`,
          style: "notesTitle",
          width: "*",
        },
        {
          columns: [
            {
              image: step3OTODataURL,
              height: 80,
              width: 80,
            },

            {
              text: `\n${t("SELECCIONA ABRIR AHORA")}`,
            },
          ],
        },
        {
          text: `${t("PASO 4")}`,
          style: "notesTitle",
          width: "*",
        },
        {
          columns: [
            {
              image: step4OTODataURL,
              height: 80,
              width: 120,
            },

            {
              text: `\n${t("DISPONES DE 2 APERTURAS")}`,
            },
          ],
        },
      ],

      styles: {
        // Document Footer
        documentFooterLeft: {
          fontSize: 10,
          margin: [5, 5, 5, 5],
          alignment: "left",
        },
        documentFooterCenter: {
          fontSize: 10,
          margin: [5, 5, 5, 5],
          alignment: "center",
        },
        documentFooterRight: {
          fontSize: 10,
          margin: [5, 5, 5, 5],
          alignment: "right",
        },
        invoiceTitle: {
          fontSize: 22,
          bold: true,
          alignment: "right",
          margin: [0, 0, 0, 15],
        },
        instrucciones: {
          fontSize: 22,
          bold: true,
          alignment: "left",
          margin: [0, 0, 0, 15],
        },
        invoiceSubTitle: {
          fontSize: 12,
          alignment: "right",
        },
        invoiceSubValue: {
          fontSize: 12,
          alignment: "right",
        },
        invoiceBillingTitle: {
          fontSize: 14,
          bold: true,
          alignment: "left",
          margin: [0, 20, 0, 5],
        },
        invoiceBillingDetails: {
          alignment: "left",
          bold: true,
        },
        itemsHeader: {
          margin: [0, 5, 0, 5],
          bold: true,
        },
        itemTitle: {
          bold: true,
        },
        itemNumber: {
          margin: [0, 5, 0, 5],
          alignment: "center",
        },
        itemTotal: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "center",
        },

        itemsFooterSubTitle: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "right",
        },
        itemsFooterSubValue: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "center",
        },
        foto1: {
          alignment: "left",
        },
        itemsFooterTotalTitle: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "right",
        },
        itemsFooterTotalValue: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "center",
        },
        signaturePlaceholder: {
          margin: [0, 70, 0, 0],
        },
        signatureName: {
          bold: true,
          alignment: "center",
        },
        signatureJobTitle: {
          italics: true,
          fontSize: 10,
          alignment: "center",
        },
        notesTitle: {
          fontSize: 16,
          bold: true,
          margin: [0, 10, 0, 3],
          alignment: "center",
        },
        notesText: {
          fontSize: 10,
        },
        center: {
          alignment: "center",
        },
      },
      defaultStyle: {
        columnGap: 20,
      },
    };

    const docOTOPinDefinition = {
      footer: {
        columns: [
          {
            text: `${t("Más información y garantía en www.vacway.com")}`,
            style: "documentFooterCenter",
          },
        ],
      },
      content: [
        {
          columns: [
            {
              image: logocolorDataURL,
              width: 150,
            },

            [
              {
                text: `${t("TICKET")}`,
                style: "invoiceTitle",
                width: "*",
              },
              {
                stack: [
                  {
                    columns: [
                      {
                        text: `${t("Factura Simplificada")}`,
                        style: "invoiceSubTitle",
                        width: "*",
                      },
                      {
                        text: `${lockerInvoice}`,
                        style: "invoiceSubValue",
                        width: 150,
                      },
                    ],
                  },
                  {
                    columns: [
                      {
                        text: `${t("Fecha y Hora")}`,
                        style: "invoiceSubTitle",
                        width: "*",
                      },
                      {
                        text: new Date().toLocaleString(),
                        style: "invoiceSubValue",
                        width: 150,
                      },
                    ],
                  },
                ],
              },
            ],
          ],
        },
        {
          columns: [
            {
              text: `${t("INFORMACIÓN DE TU LOCKER:")}`,
              style: "invoiceBillingTitle",
            },
            {
              text: "VACWAY WATERPROOF S.L",
              style: "invoiceBillingTitle",
            },
          ],
        },
        {
          columns: [
            {
              text: `${t("Nº TAQUILLA")}:  ${lockerMatricula}\n ${t(
                "PIN"
              )}: ${lockerPin}\n ${t("ZONA")}: ${zoneSelected} \n ${t(
                "TIPO"
              )}: ${this.getLockerType(selectedLocker)}\n ${t(
                "ACCESIBLE"
              )}: ${selectedAccessibility} \n ${t(
                "UBICACIÓN"
              )}: ${lockerCustomer}`,
              style: "invoiceBillingDetails",
            },
            {
              text: "Albert Einstein, 46 \n 08223 Terrassa \n Barcelona, España \n NIF: B66983032",
              style: "invoiceBillingDetails",
            },
          ],
        },
        "\n\n",
        {
          table: {
            headerRows: 1,
            widths: ["*", 40, "auto", 40, "auto", 80],

            body: [
              [
                {
                  text: `${t("Producto")}`,
                  style: "itemsHeader",
                },
                {
                  text: `${t("UNIDADES")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("IMPORTE BASE")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("IVA")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("IMPORTE IVA")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("TOTAL")}`,
                  style: ["itemsHeader", "center"],
                },
              ],
              [
                [
                  {
                    text: `${this.getLockerType(selectedLocker)}`,
                    style: "itemTitle",
                  },
                ],
                {
                  text: "1",
                  style: "itemNumber",
                },
                {
                  text: `${importeBase}`,
                  style: "itemNumber",
                },
                {
                  text: `${iva}%`,
                  style: "itemNumber",
                },
                {
                  text: `${importeIva}`,
                  style: "itemNumber",
                },
                {
                  text: `${total}`,
                  style: "itemTotal",
                },
              ],
              // END Items
            ],
          },
          layout: "lightHorizontalLines",
        },
        {
          text: `${t("PASO 1")}`,
          style: "notesTitle",
          width: "*",
        },
        {
          columns: [
            {
              image: step1DataURL,
              height: 80,
              width: 80,
            },

            {
              text: `\n${t("LOCALIZA TU TAQUILLA")}`,
            },
          ],
        },
        {
          text: `${t("PASO 2")}`,
          style: "notesTitle",
          width: "*",
        },
        {
          columns: [
            {
              image: step2DataURL,
              height: 80,
              width: 80,
            },

            {
              text: `\n${t("TOCA EL TECLADO")}`,
            },
          ],
        },
        {
          text: `${t("PASO 3")}`,
          style: "notesTitle",
          width: "*",
        },
        {
          columns: [
            {
              image: step3DataURL,
              height: 80,
              width: 80,
            },

            {
              text: `\n${t("INTRODUCE TU PIN")}`,
            },
          ],
        },
        {
          text: `${t("PASO 4")}`,
          style: "notesTitle",
          width: "*",
        },
        {
          columns: [
            {
              image: step4DataURL,
              height: 80,
              width: 120,
            },

            {
              text: `\n${t(
                "ABRE 1 VEZ PARA GUARDAR TUS COSAS, UNA VEZ CIERRES DISPONES DE UNA APERTURA MÁS PARA SACARLAS"
              )}`,
            },
          ],
        },
      ],

      styles: {
        // Document Footer
        documentFooterLeft: {
          fontSize: 10,
          margin: [5, 5, 5, 5],
          alignment: "left",
        },
        documentFooterCenter: {
          fontSize: 10,
          margin: [5, 5, 5, 5],
          alignment: "center",
        },
        documentFooterRight: {
          fontSize: 10,
          margin: [5, 5, 5, 5],
          alignment: "right",
        },
        invoiceTitle: {
          fontSize: 22,
          bold: true,
          alignment: "right",
          margin: [0, 0, 0, 15],
        },
        instrucciones: {
          fontSize: 22,
          bold: true,
          alignment: "left",
          margin: [0, 0, 0, 15],
        },
        invoiceSubTitle: {
          fontSize: 12,
          alignment: "right",
        },
        invoiceSubValue: {
          fontSize: 12,
          alignment: "right",
        },
        invoiceBillingTitle: {
          fontSize: 14,
          bold: true,
          alignment: "left",
          margin: [0, 20, 0, 5],
        },
        invoiceBillingDetails: {
          alignment: "left",
          bold: true,
        },
        itemsHeader: {
          margin: [0, 5, 0, 5],
          bold: true,
        },
        itemTitle: {
          bold: true,
        },
        itemNumber: {
          margin: [0, 5, 0, 5],
          alignment: "center",
        },
        itemTotal: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "center",
        },

        itemsFooterSubTitle: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "right",
        },
        itemsFooterSubValue: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "center",
        },
        foto1: {
          alignment: "left",
        },
        itemsFooterTotalTitle: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "right",
        },
        itemsFooterTotalValue: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "center",
        },
        signaturePlaceholder: {
          margin: [0, 70, 0, 0],
        },
        signatureName: {
          bold: true,
          alignment: "center",
        },
        signatureJobTitle: {
          italics: true,
          fontSize: 10,
          alignment: "center",
        },
        notesTitle: {
          fontSize: 16,
          bold: true,
          margin: [0, 10, 0, 3],
          alignment: "center",
        },
        notesText: {
          fontSize: 10,
        },
        center: {
          alignment: "center",
        },
      },
      defaultStyle: {
        columnGap: 20,
      },
    };

    pdfMake
      .createPdf(
        qrMode === 0
          ? docDefinition
          : qrMode === 3
          ? docOTOPinDefinition
          : docOTODefinition
      )
      .download(`VACWAYlockers-${lockerInvoice}.pdf`);
    this.setState({ downloadingPDF: false });
  };
}

const mapStateToProps = (state) => ({
  auth: true,
});

const mapDispatchToProps = (dispatch) => ({
  push: bindActionCreators(push, dispatch),
  postBookemail: bindActionCreators(postBookemail, dispatch),
  postQrsale: bindActionCreators(postQrsale, dispatch),
  postRedsysGetParams: bindActionCreators(postRedsysGetParams, dispatch),
  fetchCustomer: bindActionCreators(fetchCustomer, dispatch),
  postBooking: bindActionCreators(postBooking, dispatch),
});

export default withNamespaces()(
  connect(mapStateToProps, mapDispatchToProps)(TicketView)
);
